import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from "react-accessible-accordion"
import "react-accessible-accordion/dist/fancy-example.css"
import Image from "gatsby-plugin-sanity-image"
import BlockContent from "../blockContent";

const darkcolors = ["Red", "Black"]
export default function BuiltForSegment({ segment }) {
  return (
    <div className="builtForSegment" style={{ backgroundColor: segment.segstyle?.bg.value, padding: "50px 0" }}>
      <section className="faq-area">
        <div className="container container-fluid">
          <div className="row align-items-center">

            <div className="col-lg-5 col-md-12">
              <div className="faq-image">
                {segment.image && <Image {...segment.image} width={600} alt={segment.title} className="mt-3 mb-3" />}
              </div>
            </div>
            <div className="col-lg-7 col-md-12">
              <div className="faq-accordion">
                <h2>{segment.title}</h2>

                <Accordion allowZeroExpanded={true}>
                  {segment.builtfor_items.map((item, index) => (
                    <AccordionItem key={item._key}>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          {item.title}
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <BlockContent blocks={item.description} />
                      </AccordionItemPanel>
                    </AccordionItem>
                  ))}
                </Accordion>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  )
}